<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/expenses">{{ $t('expense_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('expense_create') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('vendor')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" readonly v-model="model.VendorName" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="$v.date.$model" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('invoice_no')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" readonly v-model="model.DocSourceNo" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.AccountId.$error }">
                                <label class="label-control blue">{{$t('payment_menthod')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.model.AccountId.$model">
                                        <option v-for="(ret,index) in banks" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('total_amount')}}</label>
                                <div>
                                    <input type="number" class="form-control form-control-sm" min="0" readonly v-model="model.Amount" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.PaidAmount.$error }">
                                <label class="label-control blue">{{$t('receive_amount')}}</label>
                                <div>
                                    <input type="number" class="form-control form-control-sm" min="0" v-model="$v.model.PaidAmount.$model" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group class="label-control blue" :label="$t('description')" :class="{ 'form-group-error': $v.model.Description.$error }">
                                <b-form-textarea v-model="$v.model.Description.$model" />
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, minValue } from 'vuelidate/lib/validators'
    export default {
        data: function () {
            return {
                model: {
                    Date: '',
                    Description: '',
                    AccountId: '',
                    DocSourceNo: '',
                    Amount: 0,
                    PaidAmount: 0
                },
                date: this.$now().format('YYYY-MM-DD'),
                banks: [],
                actionLink: 'po/receipt/save'
            }
        },
        validations: {
            model: {
                AccountId: { required },
                Description: { required },
                PaidAmount: { required, minValue: minValue(0) }
            },
            date: { required }
        },
        created: function () {
            this.bankList();
            this.findById(this.$route.params.id);
        },
        methods: {
            findById(id) {
                var loading = this.$loading.show();
                this.$api().post('po/receipt/paid', { Id: id }).then(res => {
                    if (this.$isValid(res)) {
                        this.model = res.data.Json.Header;
                        this.model.AccountId = '';
                    }
                }).finally(function () { loading.hide(); });
            },
            clickSaveHandler() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var loading = this.$loading.show();
                    this.model.Date = this.date;
                    this.model.CompanyId = this.$store.state.company.Id;
                    this.model.ClientId = this.$store.state.company.ClientId;
                    this.$api().post('po/receipt/save', this.model).then(res => {
                        if (this.$isValid(res)) {
                            this.$router.go(-1);
                        }
                    }).finally(function () { loading.hide(); });
                }
            },
            bankList() {
                this.$api().post('accounting/account/types', { AccountTypeNames: ['Bank'] }).then(res => {
                    if (this.$isValid(res)) {
                        this.banks = res.data.Json.Accounts;
                    }
                });
            }
        }
    }
</script>